const GIFTING_ALERT_STYLES = [
  {
    value: 'priority_plus_roundup',
    label: 'Priority + Daily Roundup',
    sublabel: "Priority alerts as they arrive, plus a 6pm ET roundup of the day's requests."
  },
  { value: 'priority_only', label: 'Priority only', sublabel: 'Alerts for priority gifting. General messages arrive silently.' },
  { value: 'all', label: 'All requests', sublabel: 'An alert for every request as it arrives.' }
];

const DEFAULT_GIFTING_ALERT_STYLE = 'priority_plus_roundup';

const isValidGiftingAlertStyle = style => GIFTING_ALERT_STYLES.some(({ value }) => value === style);

module.exports = {
  GIFTING_ALERT_STYLES,
  DEFAULT_GIFTING_ALERT_STYLE,
  isValidGiftingAlertStyle
};
